import { useQuery } from "@tanstack/react-query";
import { apiGet } from "../../api/client";
import type { AdminReports } from "../../types";

export function AdminReportsPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["admin-reports"],
    queryFn: () => apiGet<AdminReports>("/api/admin/reports"),
  });

  if (isLoading) return <p className="text-muted">Loading reports...</p>;
  if (!data) return <p>No data.</p>;

  return (
    <div className="admin-reports">
      <h1>Reports</h1>

      {/* Platform stats */}
      <div className="card">
        <h3>🌐 Platform Overview</h3>
        <div className="stats-grid">
          <div className="stat-card">
            <span className="stat-value">{data.platform.total_learners}</span>
            <span className="stat-label">Total Learners</span>
          </div>
          <div className="stat-card">
            <span className="stat-value">{data.platform.dialogs_completed}</span>
            <span className="stat-label">Dialogs Completed</span>
          </div>
          <div className="stat-card">
            <span className="stat-value">{data.platform.curricula}</span>
            <span className="stat-label">Curricula</span>
          </div>
        </div>
      </div>

      {/* Per-instructor breakdown */}
      <div className="card">
        <h3>👩‍🏫 Per-Instructor Breakdown</h3>
        {data.instructors.length === 0 ? (
          <p className="text-muted">No instructors configured.</p>
        ) : (
          <table>
            <thead>
              <tr><th>Instructor</th><th>Curricula</th><th>Cohort Size</th><th>Avg Mastery</th></tr>
            </thead>
            <tbody>
              {data.instructors.map((inst, i) => (
                <tr key={i}>
                  <td><strong>{inst.name}</strong></td>
                  <td>{inst.curricula}</td>
                  <td>{inst.cohort_size}</td>
                  <td>
                    <span className={inst.avg_mastery >= 70 ? "text-success" : inst.avg_mastery >= 50 ? "text-warning" : "text-danger"}>
                      {inst.avg_mastery}%
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
